export default {
  currentDeviceIndex: 0,
  current_delete_device_index: null,
  devices: []
}
